module.exports = __webpack_public_path__ + "static/media/network_bg1.2baefd93.png";